var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68713 11.1029L1 15.1441V19.8588H15.731V15.1441L11.0439 11.1029",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.383 5.04118C12.383 2.8093 10.5843 1 8.36544 1C6.14662 1 4.3479 2.8093 4.3479 5.04118V7.73529C4.3479 9.96717 6.14662 11.7765 8.36544 11.7765C10.5843 11.7765 12.383 9.96717 12.383 7.73529V5.04118Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3479 5.71471C4.89027 5.60695 5.59334 5.41162 6.35667 5.04118C7.24723 4.61012 7.91012 4.10498 8.36544 3.69412",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.383 5.71471C11.5259 5.82921 10.3742 5.89656 9.03505 5.71471C7.96371 5.56653 7.05976 5.30385 6.35669 5.04118",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7397 19.8588H25.1052V15.9995L21.2685 12.6925",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8894 12.6925L16.4006 13.1235",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3666 7.73529C22.3666 5.90886 20.8947 4.42826 19.0789 4.42826C17.2632 4.42826 15.7913 5.90886 15.7913 7.73529V9.93773C15.7913 11.7641 17.2632 13.2448 19.0789 13.2448C20.8947 13.2448 22.3666 11.7641 22.3666 9.93773V7.73529Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7913 8.28759C16.2399 8.20003 16.809 8.03838 17.4318 7.73529C18.1616 7.38506 18.704 6.96747 19.0723 6.6307",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3667 8.28758C21.6636 8.38187 20.7262 8.43576 19.628 8.28758C18.7509 8.16635 18.0143 7.95082 17.4385 7.73529",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffBlue);
export default __webpack_public_path__ + "static/media/StaffBlue.feb2f3c42deeef29b93a8df8deb517dd.svg";
export { ForwardRef as ReactComponent };